define('rebrush/components/product/type/configurable',[
	'jquery',
	'lodash',
	'cartware/components/Registry',
	'cartware/components/_base',
	'cartware/jquery/bem',
	'bootstrap-popover',
	'bootstrap-button'
], function(
	$,
	_,
	Registry,
	Component,
	BEM
) {
	var $document = $(document);

	return Component.create({
		stockBlock:			null,
		priceBlock:			null,
		spConfig:			null,
		destructorCallbacks: null,

		constructor: function() {
			this.destructorCallbacks = [];
		},

		$init: function() {
			this.block = BEM.block('product-view');
			this.stockBlock = BEM.block('product-detail-stock-status');
			this.priceBlock = BEM.block('product-detail-price');
			this.stockWrap  = this.block.find(BEM.block('product-detail-stock-wrap'));
			this.eolStatusWrap = this.block.find(BEM.block('product-detail-eol-status-wrap'));
			this.eolStatusBlock = BEM.block('product-detail-eol-status');
			this.wtbExternalBlock = BEM.block(this.block.find(BEM.block('gigaset-wheretobuy-external')));
			this.wtbExternalDisplay = this.wtbExternalBlock.getElements('display');
			this.deliveryTimeBlock = BEM.block(this.block.find(BEM.block('product-delivery-time')));
			this.metaWrap = this.block.find(BEM.block('product-detail-seo-meta-wrap'));
			this.metaBlock = this.block.find(BEM.block('product-detail-seo-meta-json'));
			this.mediaBlock = BEM.block('product-media');
			// this.itemPropOffersBlock = BEM.block(this.block.find(BEM.block('product-detail-seo-itemprop-offers')));

			this.initializeDeliveryTime();
			this.initializeWtbExternal();
			this.initializeEol();
			this.initializeStock();
			this.initializePrice();
			this.initializeProductConfig();
			this.initializeMetaData();
		},

		initializeProductConfig: function() {
			var spConfigData = _.get(window, 'spConfigData');

			if (spConfigData) {
				var urlMatches = /[#?](.+)/.exec(document.location),
					preselect = false;

				if (urlMatches) {
					$.each(urlMatches[1].split("&"), $.proxy(function(i, fragment) {
						var parts = /(.+?)=([^&=]+)/.exec(fragment);

						if (!parts) return;

						if (parts[1] === 'preselect') {
							preselect = parts[2];
						}
					}, this));
				}

				var simplesArray = _.get(Product.Config, 'prototype._configurable.simples', {});

				var sortedSimples = _.sortBy(simplesArray,function (o){
					if (preselect) {
						return parseInt(o.id) == preselect ? 0 : 1;
					}
					if (o.is_available) {
						return 0;
					}
					if (o.priority) {
						return parseInt(o.priority);
					}
					return 1000;
				});

				if (!_.isEmpty(sortedSimples)) {
					_.merge(spConfigData, {
						defaultValues: _.reduce(
							_.get(_.head(sortedSimples), 'attributes'),
							function(acc, value, key) {
								acc[key] = _.get(value, 'value');
								return acc;
							},
							{}
						)
					});
				}

				this.spConfig = new Product.Config(spConfigData);
				window.spConfig = this.spConfig;
				Registry().register('product.view.configurable.spConfig', this.spConfig);
				this.destructorCallbacks.push(function() {
					Registry().unregister('product.view.configurable.spConfig');
				});
			}
		},

		initializeWtbExternal: function() {
			var defaultElement = this.wtbExternalBlock.getElements('static'),
				tmpl = _.template(this.wtbExternalBlock.find('[data-template]').html()),
				blockCache = {};

			var _onSimpleChange = _.bind(function (e, simple) {
				var wtbText = simple.wtb.external_product_text || '',
					wtbCtaLabel = simple.wtb.external_product_link_label || '',
					wtbCtaUrl = simple.wtb.external_product_link || '',
					block;

				if (simple
					&& (
						wtbText
						|| (wtbCtaLabel && wtbCtaUrl)
					)
				) {
					block = blockCache[simple.id] || null;

					if (!block) {
						block = $(tmpl({
							text: wtbText,
							label: wtbCtaLabel,
							url: wtbCtaUrl
						}));

						blockCache[simple.id] = block;
					}

					this.wtbExternalDisplay.empty();
					this.wtbExternalDisplay.append(block);
					this.wtbExternalBlock.show();
				} else {
					this.wtbExternalDisplay.empty();
					this.wtbExternalDisplay.append(defaultElement);
					this.wtbExternalBlock.hide();
				}
			}, this);

			$document.on('product/changeSimple', _onSimpleChange);
			this.destructorCallbacks.push(function() {
				$document.off('product/changeSimple', _onSimpleChange);
			});
		},

		initializeDeliveryTime: function() {
			var _onSimpleChange = _.bind(function (e, simple) {
				var isEol = simple.is_eol || false;

				if (isEol) {
					this.deliveryTimeBlock.hide();
				} else {
					this.deliveryTimeBlock.show();
				}
			}, this);

			$document.on('product/changeSimple', _onSimpleChange);
			this.destructorCallbacks.push(function() {
				$document.off('product/changeSimple', _onSimpleChange);
			});
		},

		initializeEol: function() {
			var defaultElement = this.eolStatusBlock.getElements('default'),
				tmpl = _.template(this.eolStatusBlock.find('[data-template]').html()),
				blockCache = {};

			var _onSimpleChange = _.bind(function (e, simple) {
				var isEol = simple.is_eol || false,
					eolCtaLabel = simple.eol_cta_label || '',
					eolCtaUrl = simple.eol_cta_url || '',
					block;

				if (simple) {
					block = blockCache[simple.id] || null;

					if (!block && isEol) {
						block = $(tmpl({
							label: eolCtaLabel,
							url: eolCtaUrl
						}));

						blockCache[simple.id] = block;
					}

					this.eolStatusBlock.empty();
					this.eolStatusBlock.append(block);
					this.eolStatusWrap.show();
				} else {
					this.eolStatusBlock.empty();
					this.eolStatusBlock.append(defaultElement);
					this.eolStatusWrap.hide();
				}
			}, this);

			$document.on('product/changeSimple', _onSimpleChange);
			this.destructorCallbacks.push(function() {
				$document.off('product/changeSimple', _onSimpleChange);
			});
		},

		initializeStock: function() {
			var defaultElement = this.stockBlock.getElements('default'),
				tmpl = _.template(this.stockBlock.find('[data-template]').html()),
				blockCache = {};

			var _onSimpleChange = _.bind(function (e, simple) {
				var status,
					block,
					isEol;

				if (simple) {
					status = simple.stock_status;
					block = blockCache[status] || null;
					isEol = simple.is_eol || false;

					if (!block) {
						block = $(tmpl({
							stockStatus: status,
							isEol: isEol,
						})).bemAddModifier(status);

						blockCache[status] = block;
					}

					this.stockBlock.empty();
					this.stockBlock.append(block);
					this.stockWrap.show();
				} else {
					this.stockBlock.empty();
					this.stockBlock.append(defaultElement);
					this.stockWrap.hide();
				}
			}, this);

			$document.on('product/changeSimple', _onSimpleChange);
			this.destructorCallbacks.push(function() {
				$document.off('product/changeSimple', _onSimpleChange);
			});
		},

		initializePrice: function() {
			var fromLabel = this.priceBlock.findBlock('price').getElements('label-from');

			function _onSimpleChange(e, simple) {
				if (simple) {
					fromLabel.hide();
				} else {
					fromLabel.show();
				}
			}

			$document.on('product/changeSimple', _onSimpleChange);
			this.destructorCallbacks.push(function() {
				$document.off('product/changeSimple', _onSimpleChange);
			});
		},

		initializeMetaData: function() {
			// meta data
			var _onSimpleChange = _.bind(function (e, simple) {
				if (simple && typeof simple.meta !== "undefined") {
					var simpleMetaData = simple.meta;
					var self = this;

					// iterate simple meta data
					_.each(simpleMetaData, function (data, index) {
						// HEAD - Meta Tags
						self.setMetaTag(index, data);
					});
					// BODY - Json LD
					this.setMetaJsonLd(simple);
				}
			}, this);

			// initial
			var currentSimple = _.get(window, 'spConfig.__currentSimple');
			if (currentSimple) {
				_onSimpleChange(null, currentSimple);
			}

			$document.on('product/changeSimple', _onSimpleChange);
			this.destructorCallbacks.push(function() {
				$document.off('product/changeSimple', _onSimpleChange);
			});
		},

		setMetaTag: function (identifier, data) {
			if (identifier === 'keyword') {
				identifier = 'keywords';
			}

			var metaTag = $(`head meta[name="${identifier}"]`);

			if (typeof metaTag !== "undefined" && metaTag.length > 0) {
				metaTag.attr('content', data);
			} else {
				var head = $('head');
				head.append(`<meta name="${identifier}" content="${data}">`);
			}
		},

		setMetaJsonLd: function (simple) {
			var metaJson = this.metaBlock.find('#metaJsonTypeProduct') || null;
			var optionPrices = window.optionsPrice || null;

			if (metaJson && metaJson[0]) {
				try {
					var json = JSON.parse(metaJson[0].textContent.trim());

					// simple attributes
					if (simple.sku) {
						json.sku = simple.sku;
					}
					if (simple.product_name) {
						json.name = simple.product_name;
					}

					// Itemprop Offer
					if (json.offers) {
						if(simple.price && simple.price.currency_code) {
							json.offers.priceCurrency = simple.price.currency_code;
						}
						if (optionPrices && optionPrices.productPrice) {
							json.offers.price = optionPrices.productPrice + optionPrices.optionPrices.config.price;
						}
						if (simple.stock_status) {
							json.offers.availability = simple.stock_status === 'low' ? 'https://schema.org/OutOfStock' : 'https://schema.org/InStock';
						}
					}

					// gallery image
					var galleryItem = this.mediaBlock.getElements('gallery-list-item--visible');
					var primaryImage = galleryItem ? galleryItem.find('img') : null;
					if (primaryImage) {
						json.image = primaryImage.attr('src');
					}

					simpleJson = JSON.stringify(json);
					// replace Json LD content with simple json
					metaJson.attr('content', simpleJson);
					metaJson.text(JSON.stringify(json, null, 2));

				} catch (error) {
					console.error("Error parsing Meta JSON-LD:", error);
				}
			}
		},

		destructor: function() {
			_.forEach(this.destructorCallbacks, function(fn) { fn.call(this); }, this);
			this.destructorCallbacks = [];
			this.spConfig = null;
			window.spConfig = null;
			delete window.spConfig;
		}
	});
});

